/**
 * Bitte diese Sammlung langsam ablösen durch _loadingHelpers/Address!
 * einige Wizard-spezifische Typen dürfen natürlich bestehen bleiben
 * (zb WizardFormdata und alles was speziell als Json für den Wizard zusammengebaut ist)
 */

import { ExtendedProperties } from "../PropertyList/ExtendedPropertyTypes";
import { TodoAppointment } from "../TodoAppointments/TodoAppointmentsTypes";
import { RelatedAddress } from "./RelatedAddresses/RelatedAddressTypes";

enum AddressClassnames {
    "vt_organisations" = "vt_organisations",
    "organisations_external" = "organisations_external",
    "organisations_internal" = "organisations_internal",
    "persons" = "persons",
    "associates" = "associates",
    "contact_persons" = "contact_persons",
    "vt_telecommunication" = "vt_telecommunication",
    "email_addresses" = "email_addresses",
    "vt_addresses" = "vt_addresses"
}

export {
    AddressClassnames
}

export namespace AddressWizardTypes {


    interface Salutation {
        ID: string;
        Classname: string;
    }

    interface ProfessionalTitle {
        ID: string;
        Classname: string;
        description_short: string;
        description: string;
    }


    interface AcademicTitle {
        ID: string;
        Classname: string;
        description_short: string;
    }

    interface Country {
        ID: string;
        Classname: string;
        description: string;
    }

    interface PostalCode {
        ID: string;
        Classname: string;
        postal_code: string;
        city: string;
        ref_country: Country;
    }


    interface Citizenship {
        ID: string;
        Classname: string;
        description: string;
    }

    interface File {
        ID: string;
        Classname: string;
        filename: string;
    }

    export interface HtFile {
        ID: string;
        Classname: string;
        ref_vt_file: File;
    }

    export interface AddressCategory {
        ID: string;
        Classname: string;
        description: string;
    }

    export interface HtAddressCategory {
        ID: string;
        Classname: string;
        c_address_category: string;
        ref_address_category: AddressCategory;
    }

    export interface Telecommunication {
        ID: string;
        Classname: string;
        telecom_code: string;
    }

    export interface vt_Telecomunication{
        ID: string;
        description: string;
        Classname: string;
        ClassPrintname: string;
        $Displayname: string;
        $ClassName: string;
        $ClassPrintname:string;
    }

    export interface GetDataResponse {
        address: AddressEntity;
        associates: Array<AssociateEntity>;
        contactPerson: Array<ContactPersonEntity>;
        orgContactPersons: Array<ContactPersonEntity>;
        todoAppointments: Array<TodoAppointment>;
    }

    export interface AddressEntity extends Address_VATattributes {
        ID: string;
        Classname: string;
        gDisp_1?: string;
        gDisp_Firstname_Name: string;
        vt_organisations___name_2: string;
        vt_organisations___name_3: string;
        persons___ref_salutation: Salutation;
        persons___ref_professional_title: ProfessionalTitle;
        persons___ref_academic_title_prefix: AcademicTitle;
        persons___ref_academic_title_suffix: AcademicTitle;
        persons___name_first: string;
        name: string;
        street: string;
        ref_postal_code: PostalCode;
        ref_country: Country;
        c_postal_code: string;
        c_city: string;
        persons___ref_citizenship: Citizenship;
        note: string;
        persons___day_of_birth: Date;
        persons___day_of_death: string;
        is_active: boolean;
        persons___is_opus_address: boolean;
        persons___born: string;
        persons___died: string;
        is_perfomer: boolean;
        pseudonym: string;
        tax_no: string;
        
        EL_root_ht_files: HtFile[];
        EL_performers_address: any[];
        EL_banking_accounts_address: any[];
        EL_further_addresses_base_address: any[];
        EL_ht_address_adresscategory_address: HtAddressCategory[];
        EL_vt_telecommunications_adress: Telecommunication[];
        communicationObject: vt_Telecomunication[];
        extendedPropertyAssignments: ExtendedProperties.PropertyAssignment<AddressEntity>[];

        ref_class_level?: any;
        ref_language?: any;
    }

    export interface Address_VATattributes {
        VAT_no: string;
        VAT_no_checked_at: string;
        is_VAT_No_valid: boolean;
    }

 
        interface JobTitle {
        ID: string;
        value: string;
        description: string;

    }

    //export interface FunctionalSubGroup extends more.EntityAPIResult{
    //    description: string;
    //}

    interface Address_Base extends more.EntityAPIResult {
        gDisp_1: string;
        is_active?: boolean;
    }

    export interface Organisation extends Address_Base {
    }

    export interface Person extends Address_Base {

    }

    export interface ContactPersonEntity {
        ID: string;
        Classname: string;
        $Displayname: string;
        gDisp_1: string;
        gDisp_Name_Firstname?: string;
        ref_job_title: JobTitle;
        c_job_title: string;
        ref_person: Person;
        ref_organisation: Organisation;
        EL_ht_address_adresscategory_address: HtAddressCategory[];
        EL_vt_telecommunications_adress: Telecommunication[];
        ref_address_types: any;
        ref_division?: any;
        ref_country?: Country;
        ref_language?: any;
    }

    export interface OrganisationContactPersonEntity extends ContactPersonEntity {
        ref_person: any;

    }
    export interface AssociateEntity extends ContactPersonEntity {
        EL_vt_internal_contract_md_associate: any[];
    }

    //export interface ContactPersonAssignment_Stump {
    //    type: string;
    //    contactPersonType: string;
    //    organisation: ValueStump;
    //    jobTitle: Partial<JobTitle>;
    //    data: Partial<AssociateEntity>;
    //    form?: any;
    //}

    export interface ValueStump {
        ID: string;
        value: string;
        is_active?: boolean;
    }

    interface diffData_Base<T> {
        removed: Array<string>
        added: Array<T>
        list: Array<T>
    }
    export interface AddressCategoriesDiffData extends diffData_Base<AddressCategory> {
        
    }

    export interface AddressCategoryAssignment_Stump {
        type: "addressCategory";
        addressCategory: ValueStump;
    }

    export interface Profession extends more.EntityAPIResult{
        description: string;
    }
    export interface Performer_Stump {
        type: string;
        profession: ValueStump;
        isMainProfession: boolean;
        artistName: string;
    }
    export interface Performer extends more.EntityAPIResult {
        ref_ev_profession: Profession;
        is_main_profession: boolean;
        gDisp_1: string;
        ref_address?: Address_Base;
    }

    interface Location {
        type: string;
        addressDescription: string;
        street: string;
        plz: ValueStump;
        city: ValueStump;
        country: Country;
    }

    export interface FileUpload {
        guid: string;
        filenames: string[];
    }

    interface Citizenship {
        ID: string;
        Classname: string;
        lc_iso_alpha_2: string;
        description: string;
    }

    export interface WizardData {
        ID: string,
        taxNr: string,
        vatNr: string,
        bankAccount: Array<any>,
        mobile: Array<any>,
        phone: Array<any>,
        webphone: Array<any>,
        messenger: Array<any>,
        web: Array<any>,
        fax: Array<any>,
        mail: Array<any>
        addressType: "person" | "company";
        surname: string;
        firstname: string;
        performerName: string;
        mainPlzPerson: PostalCode;
        mainCityPerson: PostalCode;
        orgContactPersons: Array<OrgContactPersonListEntry>;
        contactPerson: Array<ContactPersonListEntry>;
        addressCategories: AddressCategoriesDiffData;
        performer: Performer_Stump[];
        salutation: string;
        activeCheckBox: boolean;
        mainCountryPerson: Country;
        isContactPersonCheckBox: boolean;
        isPerformerCheckBox: boolean;
        locations: Location[];
        note: string;
        titleSuffix: string;
        mainStreetPerson: string;
        titlePrefix: string;
        professionalTitle: string;
        composerBirthDate: string;
        composerDiedDate: string;
        composerDiedDate_Date: Date;
        composerBirthDate_Date: Date;
        fileUpload: FileUpload[];
        citizenship: Citizenship;
        personExtendedProperties: EntityStoreData<any>;
        todoDiffData: EntityStoreData<TodoAppointment>;
        relatedAddressDiffData: EntityStoreData<RelatedAddress>;
        addressDocumentsData?: any;
        furtherAddressesData?: any;
        GDPRData?: any;
        performerSectionData?: any;
    }

    export interface WizardDataOrg extends WizardData {
        name1: string,
        name2: string,
        name3: string
    }
    export interface ContactPersonListEntry {
        //ID?: string;
        jobTitle: ValueStump;
        data?: ContactPersonFormData
        type?: "orgContactPerson"|"contactPerson";
        contactPersonType?: string;
        organisation: ValueStump;
        entity?: ContactPersonEntity;
        form?: any;
    }

    export interface OrgContactPersonListEntry {
        person: any
        isMainOrganisation: boolean
        type?: "orgContactPersons";
        addressType: string
        data?: ContactPersonFormData
        entity?: OrganisationContactPersonEntity
    }
    export interface ContactPersonFormData {
        ID: string;
        organisation: Organisation;
        type?: "orgContactPerson" | "contactPerson";
        contactPersonType?: string;
        c_job_title: string;
        jobTitle: JobTitle;
        hasChanged?: boolean;
        addressCategory?: string[];
        isMusicianCheckBox: boolean;
        FunctionalSubGroup?: Array<{
            FunctionalSubGroup: {
                seviceObligation: number
                value: string,
                ID: string
            },
            type: string,
            ServiceObligation: number
        }>;
        profession?: Array<{
            type: string, Profession: ValueStump
        }>;
        seviceObligation?: number; // inkl Typo
        mobile?: Array<any>,
        phone?: Array<any>,
        webphone?: Array<any>,
        messenger?: Array<any>,
        web?: Array<any>,
        fax?: Array<any>,
        mail?: Array<any>,
        performer?: Array<Performer_Stump>,
        teleCommData?: Array<any>
    }

    export interface PerformerData {
        ID: string;
        Classname: string;
        $Displayname: string;
        pseudonym: string;
        EL_performers_address?: Array<Performer_Extended>;
        tableLayouts: Array<any>;
    }

    interface PerformerEnsemble extends Address_Base {
        ref_address?: Address_Base;
    }
    export interface EnsembleMember {
        ID: string;
        Classname: string;
        $Displayname: string;
        ref_ensemble?: PerformerEnsemble;
        ref_performer?: PerformerEnsemble;
        date_start: Date;
        date_end: Date;
        is_active: boolean;
        isNew?: boolean;
    }

    export interface Performer_Extended extends Performer {
        EL_ensemble_members_performer: Array<EnsembleMember>;
        EL_ensemble_members_ensemble: Array<EnsembleMember>;
    }

    export interface HideSelectedSectionsConfig {
        base?: boolean,
        telecom?: boolean,
        communicationPanel?: boolean,
        divisions?: boolean,
        organizationContactPerson?: boolean,
        addressCategory?: boolean,
        financeData?: boolean,
        addressDocuments?: boolean,
        furtherAddresses?: boolean,
        contactPersonData?: boolean,
        performer?: boolean,
        composer?: boolean,
        extendedProperty?: boolean,
        todoAppointments?: boolean,
        relatedAddresses?: boolean,
        file?: boolean,
        GDPR?: boolean,
    }
}
